import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-person',
  templateUrl: './icon-person.component.html',
  styleUrls: ['./icon-person.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconPersonComponent {}
